import React, {Component} from 'react';

const hc = 
{
	title: "Hallmark Channel",
	logo: "images/HC_Logo_New_Black.png"
}
const hmm = 
{
	title: "Hallmark Mystery",
	logo: "images/HMyst-24_LOGO_Black_v2.png"	
} 

const hd = 
{
	title: "Hallmark Family",
	logo: "images/HF_LOGO_Black.png"
}

class ProvidersHeader extends Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			channels:[]
		}
		this.displayChannels = this.displayChannels.bind(this);
	}
	
	componentDidMount()
	{
		let order = []
		switch(this.props.channel){		
			case "hmm":
				order = [hmm, hc, hd]
				break;
			case "hd":
				order = [hd, hc, hmm]
				break;
			default:
				order = [hc, hmm, hd]
		}

		this.setState(
			{
				channels:order
			}
		)
	}

	displayChannels(channel, i)
	{
		return(
			<div className="col-xs-3" key={i}>
				<div className="row">
					<img className="channel-logo" alt={channel.title} src={channel.logo}/>
				</div>
				<div className="row">
					<span className="hd-icon-text">HD</span>
					<span>  </span>
					<span className="sd-icon-text">SD</span>
				</div>
			</div>
		)
	}

	render()
	{
		return(
			<div className="row table-row table-row-grey">
				<div className="col-xs-3">
					<h3 className="table-font providers-header">Cable Providers</h3>
				</div>
				{this.state.channels.map(this.displayChannels)}
			</div>
		)
	}
}

export default ProvidersHeader;


// WEBPACK FOOTER //
// ./src/components/ProvidersHeader.js